<template>
  <funding-project-base :state="state">
    <div class="container mt-8">
      <team-section
        v-for="(partner, index) in state.team"
        :key="partner.id"
        :type="partner.type"
        :partner-id="partner.id"
        :company="partner.company"
        :team="partner.users"
        :staff="partner.staff"
        :is-admin="true"
        :class="{
          'mb-24': index + 1 !== state.team.length
        }"
      />
    </div>
  </funding-project-base>
</template>
<script>
export default {
  name: "FundingProjectsMembers"
};
</script>
